import { AxiosResponse, AxiosError } from 'axios';

import { ApiState } from 'scenes/common/types';

import { ApiError } from './types';

export const unmarshallSuccess = (response: AxiosResponse) => response.data;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unmarshallFailure = (error: AxiosError<any, any>) => {
  if (error.response) {
    if (error.response.status === 400) {
      throw new ApiError(
        'Bad request',
        ApiState.BusinessError,
        error.response.data,
        error.response?.status.toString() ?? ''
      );
    }

    if (error.response.status === 422) {
      throw new ApiError(
        'Entity cannot be processed',
        ApiState.BusinessError,
        error.response.data,
        error.response?.status.toString() ?? ''
      );
    }

    throw new ApiError(
      (error.response.data && error.response.data.message
        ? error.response.data.message
        : 'The server returned an error code') + error.response.status,
      undefined,
      undefined,
      error.response?.status.toString() ?? ''
    );
  }
  if (error.request) {
    throw new ApiError("The server didn't respond");
  }
};
